import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { readCookieConsent, writeCookieConsent } from "../utils/cookieConsent";
import "./cookie-consent.css";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readCookieConsent()) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const choose = (choice) => {
    writeCookieConsent(choice);
    setVisible(false);
  };

  return (
    <div className="nh-cookie-banner" role="dialog" aria-labelledby="nh-cookie-banner-title" aria-live="polite">
      <div className="nh-cookie-banner__inner">
        <div className="nh-cookie-banner__copy">
          <p id="nh-cookie-banner-title" className="nh-cookie-banner__title">
            We use cookies
          </p>
          <p className="nh-cookie-banner__text">
            We use cookies for login and security, and to remember your preferences. Essential cookies are always on.
            You can accept or reject non-essential cookies. See privacy notes via the site{" "}
            <Link to="/#mission" className="nh-cookie-banner__link">
              footer
            </Link>
            .
          </p>
        </div>
        <div className="nh-cookie-banner__actions">
          <button type="button" className="nh-cookie-banner__btn nh-cookie-banner__btn--ghost" onClick={() => choose("rejected")}>
            Reject non-essential
          </button>
          <button type="button" className="nh-cookie-banner__btn nh-cookie-banner__btn--primary" onClick={() => choose("accepted")}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
